import React, { useEffect } from 'react';
import { useParams } from 'umi';
import CampForm from '@/pages/backend/components/campForm';

function BasicSettings() {
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    console.log('ID from URL:', id);
  }, [id]);

  return <CampForm isModal={false} id={id} />;
}

export default BasicSettings;
